import { render, staticRenderFns } from "./ClientUserSiteAccess.vue?vue&type=template&id=4449a055&"
import script from "./ClientUserSiteAccess.vue?vue&type=script&lang=js&"
export * from "./ClientUserSiteAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports